module.exports = __webpack_public_path__ + "static/media/6.a37f50b7.jpg";